<template>
  <v-chip small :dark="!disabled" style="border-radius: 4px;" :color="stateColor()" @click="$emit('click')">
    <span class="text-truncate">
      {{ stateText() }}
    </span>
  </v-chip>
</template>


<script>
export default {
  name: "LeadsStateChip",
  props: {
    state: Number,
    disabled: Boolean,
  },
  components: {},

  data() {
    return {};
  },

  methods: {
    stateText() {
      return this.$t('servicesystem.common_objects.lead.state' + (this.state ?? 0))
    },

    stateColor() {
      if (this.disabled) {
        return 'white'
      }
      else {
        switch (this.state) {
          case 2:
            return 'success'
          case 1:
            return 'primary'
          default:
            return 'warning'
        }
      }
    }
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>